<style>
  #BtnDiv {
    position: fixed;
    bottom: 25px;
    right: 25px;
    background: #282a39b0;
    padding: 10px;
    border-radius: 5px;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Submit New Suggestion</h5>
      <form>
          <div *ngIf="canEditMainForm">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">Suggestion Subject</label>
                <select class="custom-select"  [(ngModel)]="title_id" name="title_id" >
                  <option value="0">-- Select --</option>
                  <option *ngFor="let item of Title_DataList" [value]="item.id">{{item.title}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">Suggestion Description</label>
                <ckeditor name="editorData" [(ngModel)]="model.editorData" [config]="config" [editor]="Editor"></ckeditor>
              </div>
            </div>
          </div>

          <div *ngIf="!canEditMainForm">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">Suggestion Subject</label>
                <input value="{{inner_Suggest.title}}" disabled type="text" class="form-control" >
                <label></label>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">Suggestion Description</label>
                <div innerHTML="{{inner_Suggest.dsc}}"></div>
              </div>
            </div>
          </div>

          <br/>
          <br/>
          <br/>
          <br/>

          <div *ngIf="canEditMainForm">

            <div  class="row">
              <div class="form-group col-md-12">
                <label for="exampleInputEmail1">
                  Attachments ( jpeg , png , jpg , pdf )
                  <button (click)="Remove_uploadImage1()"  type="button" *ngIf="UploadImageSrc"  class="btn  btn-danger" ><i class="fa  fa-times-rectangle"></i> </button>
                </label>
                <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
                <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file" class="form-control"  placeholder="Type here...">
              </div>
            </div>

            <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>

            <br/>
            <br/>

          </div>

          <div class="table-responsive" *ngIf="UploadImageSrc_List.length>0">
            <table class="mb-0 table table-bordered table-3 text-center table-striped">
              <thead style="background-color: #489b39; color: white;">
                <tr>
                  <th>#</th>
                  <th>File</th>

                  <th *ngIf="canEditMainForm" >Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of UploadImageSrc_List" >

                    <td>{{UploadImageSrc_List.indexOf(item)+1}}</td>
                    <td>

                      <a target="_blank" *ngIf="item.includes('.pdf')"  href="{{BaseUrl}}File/Suggest/{{item}}" class="btn btn-success" ><i class="fa fa-file-pdf-o"></i> PDF </a>


                      <img *ngIf="!item.includes('.pdf')" (click)="openModal(templateImage,item)" style="width: 150px;cursor: zoom-in;" src="{{BaseUrl}}File/Suggest/{{item}}"/>
                    </td>
                    <td *ngIf="canEditMainForm" >
                        <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                          <div class="btn-group" role="group">
                              <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Actions
                              </button>
                              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                  <a style="cursor: pointer;" (click)="UploadImageSrc_List_Delete(UploadImageSrc_List.indexOf(item))" class="dropdown-item" ><i class="fa fa-remove"></i> Delete </a>
                              </div>
                          </div>
                      </div>
                    </td>

                </tr>
              </tbody>
            </table>
          </div>

          <br/>
          <br/>

      </form>


      <br />
      <br />

      <div id="BtnDiv">

        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />

        <ng-container *ngFor="let item of Data_List_Order">

          <button *ngIf="!InProccessing" type="button" (click)="OpenOrderDialog(templateOrder,item)" [class]="item.cls" style="margin-right: 5px;"> <i [class]="item.icon"></i>
            {{item.title}} </button>
        </ng-container>

      </div>

      <br />
      <br />


  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
     <h4 class="modal-title pull-left"> View Image </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img  style="max-width: 350px;" src="{{BaseUrl}}File/Suggest/{{ModalimageUrl}}"/>
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Suggest/{{ModalimageUrl}}"   ><i class="fa fa-download"></i> Download </a>
     <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateOrder>
  <div class="modal-header">
    <h4 class="modal-title pull-left">  </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Order.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="canAnswerMainForm && Selected_Order_Operation.id!=6">
      <div class="col-md-6">
        <label for="exampleInputEmail1">Score</label>
        <select class="custom-select" [(ngModel)]="LetterHistoryPoint" >
          <option value="0">0</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
        </select>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Description</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="Type here...">
      </div>
    </div>
    <div class="row" *ngIf="!canAnswerMainForm || Selected_Order_Operation.id==6">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">Description</label>
        <input type="text" class="form-control" [(ngModel)]="LetterHistoryDsc" placeholder="Type here...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success"
      (click)="onSubmitForm()"> Submit </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Order.hide()">Close</button>
  </div>
</ng-template>
